import { Button } from '@life-line-lab/components-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';
import './controlled-drug-order-button.scss';

type Props = {};

export const ControlledDrugOrderButton = (props: Props) => {
  const isTabletOrMobile = useMediaQuery({ query: `(max-width: 62em)` });
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Button
      type="secondary"
      className="btn-w-100 controlled-drug-order-button special-button-class"
      label={t('label.controlledDrugOrder')}
      size={!isTabletOrMobile ? 'large' : undefined}
      onClick={() => history.push('/e-prescription/upload')}
    />
  );
};
